import toast from "react-hot-toast";

export const notify = (message, type = "default") => {
    switch (type) {
        case "error":
            toast.error(message);
            break;
        case "success":
            toast.success(message);
            break;
        default:
            toast(message);
    }
};